<template>
  <div class="goodsInventoryCreate">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="PId">{{ $t.goodsInventory.editProduct }}</div>
      <div class="title" v-else>{{ $t.goodsInventory.createProduct }}</div>

      <van-field
        v-model="form.ProductName"
        :label="$t.goodsInventory.productName"
        required
        :rules="formRule"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ProductNameEn"
        :label="$t.goodsInventory.productNameEn"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.CustomsDeclarationName"
        :label="$t.goodsInventory.customsDeclarationName"
        required
        :rules="formRule"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ProductDescription"
        :label="$t.goodsInventory.productDescription"
        type="textarea"
        rows="3"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.PUIdStr"
        :label="$t.goodsInventory.unitName"
        @click="pickerShow('showUnitPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <div class="custom-date">
        <div class="date-label">{{ $t.goodsInventory.priceValidityPeriod }}</div>
        <div class="date-btn1" @click="showStartDate">
          <span v-if="form.PriceStartEffectiveDate">{{
            form.PriceStartEffectiveDate
          }}</span>
          <span v-else>{{ $t.meta.beginDate }}</span>
        </div>
        <div class="date-btn2" @click="showEndDate">
          <span v-if="form.PriceExpirationDate">{{ form.PriceExpirationDate }}</span>
          <span v-else>{{ $t.meta.endDate }}</span>
        </div>
      </div>

      <van-field
        v-model="form.HSCode"
        :label="$t.goodsInventory.hsCode"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Brand"
        :label="$t.goodsInventory.brand"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Specifications"
        :label="$t.goodsInventory.specification"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Model"
        :label="$t.goodsInventory.model"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.PackageNumber"
        :label="$t.goodsInventory.packageNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.GrossWeight"
        :label="$t.goodsInventory.grossWeight"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Volume"
        :label="$t.goodsInventory.volume"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.CountryOrigin"
        :label="$t.goodsInventory.countryOrigin"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.DomesticPlaceOrigin"
        :label="$t.goodsInventory.domesticPlaceOrigin"
        :placeholder="$t.meta.input"
      />

      <div class="goodsInventoryCreate-checkboxs">
        <div class="checkbox-label">{{ $t.goodsInventory.customsDeclaration }}</div>
        <van-checkbox-group v-model="form.CustomsDeclarationList" direction="horizontal">
          <van-checkbox
            v-for="(item, index) in customsList"
            :key="index"
            :name="item.value"
            >{{ item.text }}</van-checkbox
          >
        </van-checkbox-group>
      </div>

      <div class="goodsInventoryCreate-checkbox">
        <van-checkbox style="margin: 0" v-model="form.IsBrandLicensing">{{
          $t.goodsInventory.brandLicensing
        }}</van-checkbox>
      </div>

      <div class="custom-date" v-if="form.IsBrandLicensing">
        <div class="date-label">{{ $t.goodsInventory.brandLicensingDate }}</div>
        <div class="date-btn1" @click="showBrandStartDate">
          <span v-if="form.BrandLicensingStartEffectiveDate">{{
            form.BrandLicensingStartEffectiveDate
          }}</span>
          <span v-else>{{ $t.meta.beginDate }}</span>
        </div>
        <div class="date-btn2" @click="showBrandEndDate">
          <span v-if="form.BrandLicensingExpirationDate">{{
            form.BrandLicensingExpirationDate
          }}</span>
          <span v-else>{{ $t.meta.endDate }}</span>
        </div>
      </div>

      <div class="multi-table" v-if="form.ProductImageList">
        <van-field name="stepper" :label="$t.goodsInventory.productImages">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.ProductImageList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(image, index) in form.ProductImageList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(image))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="image"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead" @click-upload="uploaderClick(index)">
                <van-image
                  :src="image && imgUrlFilter(image)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="image"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">
          {{ $t.meta.submit }}
        </van-button>
      </div>
    </van-form>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.goodsInventory.startDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.goodsInventory.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showUnitPicker" round position="bottom">
      <van-picker
        :title="$t.goodsInventory.unitName"
        show-toolbar
        :columns="unitList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="unitConfirm"
        @cancel="showUnitPicker = false"
      />
    </van-popup>

    <van-popup v-model="showBrandStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.goodsInventory.startDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="brandDateChange($event, 'start')"
        @cancel="showBrandStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showBrandEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.goodsInventory.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="brandDateChange($event, 'end')"
        @cancel="showBrandEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "goodsInventoryCreate",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      PId: "",
      form: {
        //1
        ProductName: "",
        ProductNameEn: "",
        DomesticPlaceOrigin: "",
        CustomsDeclarationName: "",
        ProductDescription: "",
        ProductImageList: [],
        HSCode: "",
        Brand: "",
        PriceStartEffectiveDate: "",
        PriceExpirationDate: "",
        IsBrandLicensing: 0,
        BrandLicensingStartEffectiveDate: "",
        BrandLicensingExpirationDate: "",
        //2
        Specifications: "",
        Model: "",
        PUIdStr: "",
        PUId: null,
        PackageNumber: "",
        GrossWeight: "",
        Volume: "",
        CountryOrigin: "",
        //3
        CustomsDeclarationList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      showEndPicker: false,
      //品牌授权有效期
      showBrandStartPicker: false,
      showBrandEndPicker: false,
      //选项
      unitList: [],
      customsList: [],
      showUnitPicker: false,
      filesIndex: 0,
    };
  },
  created() {
    const { PId } = this.$route.query;
    this.PId = PId;
    if (this.PId) {
      this.getOptions().then((success) => {
        if (success) {
          this.getProcurementProductInfoByPId();
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getProcurementQuotationUnitList(),
          this.getCustomsDeclarationList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getProcurementQuotationUnitList() {
      return new Promise((resolve) => {
        this.$api.purchasingManagement
          .getProcurementQuotationUnitList({})
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.PUId,
              };
              result.push(data);
            });
            this.unitList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomsDeclarationList() {
      return new Promise((resolve) => {
        this.$api.purchasingManagement
          .getCustomsDeclarationList({})
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.DeclarationType,
                value: item.CDId,
              };
              result.push(data);
            });
            this.customsList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    unitConfirm(e) {
      if (!e) {
        return;
      }
      this.form.PUIdStr = e.text;
      this.form.PUId = e.value;
      this.showUnitPicker = false;
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    showBrandStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showBrandStartPicker = true;
    },
    showBrandEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showBrandEndPicker = true;
    },
    handleDelByIndex(index) {
      if (this.form.ProductImageList.length > 0) {
        this.form.ProductImageList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.ProductImageList.length > 0) {
        this.form.ProductImageList.pop();
      }
    },
    handleAdd() {
      this.form.ProductImageList.push("");
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.form.PriceStartEffectiveDate = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.form.PriceExpirationDate = formatDate(date);
        this.showEndPicker = false;
      }
    },
    brandDateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.form.BrandLicensingStartEffectiveDate = formatDate(date);
        this.showBrandStartPicker = false;
      }
      if (type == "end") {
        this.form.BrandLicensingExpirationDate = formatDate(date);
        this.showBrandEndPicker = false;
      }
    },
    getProcurementProductInfoByPId() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.purchasingManagement
          .getProcurementProductInfoByPId({
            PId: this.PId,
          })
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    applyData(data) {
      this.form.PUId = data.PUId.toString();
      var unit = this.unitList.find((c) => c.value == this.form.PUId);
      if (unit) {
        this.form.PUIdStr = unit.text;
      }

      var checks = [];
      for (var customs of data.CustomsDeclarationList) {
        checks.push(customs.CDId);
      }
      this.form.CustomsDeclarationList = checks;

      this.form.ProductName = data.ProductName;
      this.form.ProductNameEn = data.ProductNameEn;
      this.form.DomesticPlaceOrigin = data.DomesticPlaceOrigin;
      this.form.CustomsDeclarationName = data.CustomsDeclarationName;
      this.form.ProductDescription = data.ProductDescription;
      this.form.ProductImageList = data.ProductImageList;
      this.form.HSCode = data.HSCode;
      this.form.Brand = data.Brand;
      this.form.PriceStartEffectiveDate = data.PriceStartEffectiveDate;
      this.form.PriceExpirationDate = data.PriceExpirationDate;
      this.form.IsBrandLicensing = data.IsBrandLicensing;
      this.form.BrandLicensingStartEffectiveDate = data.BrandLicensingStartEffectiveDate;
      this.form.BrandLicensingExpirationDate = data.BrandLicensingExpirationDate;
      this.form.Specifications = data.Specifications;
      this.form.Model = data.Model;
      this.form.PackageNumber = data.PackageNumber;
      this.form.GrossWeight = data.GrossWeight;
      this.form.Volume = data.Volume;
      this.form.CountryOrigin = data.CountryOrigin;
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        PId: null,
        ProductName: this.form.ProductName,
        ProductNameEn: this.form.ProductNameEn,
        DomesticPlaceOrigin: this.form.DomesticPlaceOrigin,
        CustomsDeclarationName: this.form.CustomsDeclarationName,
        ProductImageList: this.form.ProductImageList,
        HSCode: this.form.HSCode,
        Brand: this.form.Brand,
        PriceStartEffectiveDate: this.form.PriceStartEffectiveDate,
        PriceExpirationDate: this.form.PriceExpirationDate,
        IsBrandLicensing: this.form.IsBrandLicensing ? 1 : 0,
        BrandLicensingStartEffectiveDate: this.form.IsBrandLicensing
          ? this.form.BrandLicensingStartEffectiveDate
          : "",
        BrandLicensingExpirationDate: this.form.BrandLicensingExpirationDate
          ? this.form.BrandLicensingExpirationDate
          : "",
        Specifications: this.form.Specifications,
        Model: this.form.Model,
        PUId: this.form.PUId,
        PackageNumber: this.form.PackageNumber,
        GrossWeight: this.form.GrossWeight,
        Volume: this.form.Volume,
        CountryOrigin: this.form.CountryOrigin,
        CustomsDeclarationList: [],
      };
      var checks = [];
      for (var id of this.form.CustomsDeclarationList) {
        checks.push({
          CDId: id,
        });
      }
      param.CustomsDeclarationList = checks;
      var request = null;
      if (this.PId) {
        param.PId = this.PId;
        request = this.$api.purchasingManagement.editProcurementProduct(param);
      } else {
        request = this.$api.purchasingManagement.addProcurementProduct(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.ProductImageList[this.filesIndex] = res.data;
          this.$forceUpdate();
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.goodsInventoryCreate {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-steps {
    background: transparent;
  }
  .collapse-title {
    color: #646566;
  }
  ::v-deep .van-step__line {
    display: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px 16px;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .goodsInventoryCreate-checkboxs {
    padding: 15px;
    border-bottom: 1px solid #ebedf0;
    ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
      i {
        color: #1890ff;
        font-weight: bold;
      }
    }
    ::v-deep .van-checkbox__label {
      color: #646566 !important;
    }
    .checkbox-label {
      color: #646566;
      margin-bottom: 15px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .goodsInventoryCreate-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .date-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .date-btn1 {
      width: 47%;
      display: inline-block;
      border-right: 1px solid #ebedf0;
      vertical-align: middle;
      margin-right: 5%;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 47%;
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      color: #646566;
    }
  }
  .subTotal {
    padding: 10px 16px;
    border-bottom: 1px solid #ebedf0;
    color: #646566;
    .subTotal-label {
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #2c88c1;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .empty-text {
    text-align: center;
    padding: 20px;
    font-size: 14px;
    color: #969799;
  }
}
</style>
